import React from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  styled,
} from '@mui/material';
import { motion } from 'framer-motion';

import cloudsVideo from '../images/clouds.mp4';

const StyledHeroSection = styled(Box)(({ theme}) => ({
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(12, 0),
  textAlign: 'center',
  backgroundColor: 'transparent',
}));

const BackgroundVideo = styled('video')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -1,
  opacity: 0.3,
});

const HeroSection = () => {
  return (
    <StyledHeroSection>
      <BackgroundVideo autoPlay loop muted playsInline>
        <source src={cloudsVideo} type="video/mp4" />
      </BackgroundVideo>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant='h2'
          component= "h1"
          fontWeight="bold"
          gutterBottom
          >
            Cloud XVII
          </Typography>
          <Typography variant='h4' component="h2" primary gutterBottom>
            Websites Builted by Timothy - Frontend Beauty, Backend Power
          </Typography>
          <Typography 
          variant='h6'
          color='text.secondary'
          paragraph
          sx={{ mt: 4 }}
          >
            I design and devlop modern, responsive websites that help your business grow. from sleek landing pages to full-featured web applications, I handle every part of the process so you can focus on your business.
          </Typography>
          <Box sx={{ mt: 5 }}>
            <Button 
              variant='contained'
              size='large'
              color='secondary'
              href="/pricing" // Links to your new pricing page
              sx={{ mr: 2 }}
            >
              See Pricing
            </Button>
            <Button 
              variant='outlined'
              size='large'
              color='primary'
              href="mailto:CloudXviiDevelopment@outlook.com" // Opens a new email
            >
              Get a Free Quote
            </Button>
          </Box>
        </Container>
      </motion.div>
    </StyledHeroSection>
  );
};

export default HeroSection;